module.exports = __webpack_public_path__ + "img/프로필작성.8886522d.png";